import { render } from "./AccountDashboard.vue?vue&type=template&id=6a0cda1e&scoped=true"
import script from "./AccountDashboard.vue?vue&type=script&lang=js"
export * from "./AccountDashboard.vue?vue&type=script&lang=js"

import "./AccountDashboard.vue?vue&type=style&index=0&id=6a0cda1e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a0cda1e"]])

export default __exports__